import React from 'react'
import DeshDeepakKushwaha_Resume from '../../assets/DeshDeepakKushwaha_Resume.pdf'

const CTA = () => {
  return (
      <div className="cta">
          <a href={DeshDeepakKushwaha_Resume} download className='btn'>Download Resume</a>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA